class ComponentSecteur {
  constructor() {
    this._init();
  }

  _init() {
    const rows = document.querySelectorAll('.secteurs__row');
    const images = document.querySelectorAll(
      '.listing-secteurs__media-position'
    );

    // État initial : activer image si un secteur est déjà ouvert
    rows.forEach((row, index) => {
      if (row.classList.contains('secteurs--open')) {
        images.forEach((img) => img.classList.remove('media--active'));
        if (images[index]) {
          images[index].classList.add('media--active');
        }
      }
    });

    // Ajout des écouteurs
    rows.forEach((row, index) => {
      const header = row.querySelector('.secteurs__secteurs');

      if (header) {
        header.addEventListener('click', () => {
          const isOpen = row.classList.contains('secteurs--open');

          // Fermer tous les secteurs et masquer toutes les images
          rows.forEach((r) =>
            r.classList.remove('secteurs--open', 'secteurs__row--active')
          );
          images.forEach((img) => img.classList.remove('media--active'));

          // Si ce n'était PAS déjà ouvert, on l'ouvre
          if (!isOpen) {
            row.classList.add('secteurs--open', 'secteurs__row--active');
            if (images[index]) {
              images[index].classList.add('media--active');
            }
          }
          // Sinon (déjà ouvert), tout reste fermé/inactif
        });
      }
    });
  }
}

export const componentSecteur = new ComponentSecteur();
